import { Toolbar } from '@mui/material'
import React, { useState } from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'
import {
  DataTable,
  FilterSection,
  FilterStudent,
  SelectField,
  ToolbarComponent,
} from '../../../../../components'
// import { ImportIcon } from '../../../../../assets/icons'
import { studentHeadCells, studentTransportHeadCells } from '../../../../../shared/data/headCells'
import { useGlobal } from '../../../../../shared'
import { urls } from '../../../../../shared/config'
// import { setOpenImport } from '../../../../../redux/globalSlice'
import { useDispatch, useSelector } from 'react-redux'
import { InfoField } from '../School/PopOver/SchoolInfo'
import { highestInt } from '../../../../../shared/utils/constants'
import { ExportIcon, ImportIcon } from '../../../../../assets/icons'
import {
  setOpenExportModal,
  setOpenImport,
  setOpenTransportModal,
} from '../../../../../redux/globalSlice'
import classes from './Student.module.css'
import DashboardCard from '../../Dashboard/component/Card'
import NewSelectedField from '../../../../../common/NewSelectedField/NewSelectedField'
import AddNewStudentModal from './component/AddNewStudentModal/AddNewStudentModal'
import ExportTransportReport from './component/ExportTransportReport/ExportTransportReport'
import CollectFeesModal from './component/CollectFeesModal/CollectFeesModal'
import { downloadCSV } from '../../../../../shared/config/downloadCSV'
import { toast } from 'react-toastify'
const StudentList = () => {
  // const analyticsData = [
  //   {
  //     title: 'Total Students',
  //     content: '1500',
  //   },
  //   {
  //     title: 'Paid Fees',
  //     content: '$500,000',
  //   },
  //   {
  //     title: 'Unpaid Fees',
  //     content: '$500,000',
  //   },
  // ]

  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type
  const [page, setPage] = useState(1)
  const [selectedGrade, setSelectedGrade] = useState('')
  const [selectedClass, setSelectedClass] = useState('')
  const [selectedMonth, setSelectedMonth] = useState('')
  const dispatch = useDispatch()
  // console.log('----customRole',customRole);

  const [openSchoolInfo, setSchoolInfo] = useState(false)
  const [search, setSearch] = useState('')
  const rowsPerPage = useSelector((state) => state.global.rowsPerPage)
  const modalOpen = useSelector((state) => state.global.openTransportModal)
  const exportOpen = useSelector((state) => state.global.openExportModal)
  const collectFeeOpen = useSelector((state) => state.global.openFeeCollection)
  const school_fee_method = localStorage.getItem('school_fee_method')

  const [schoolName, setSchoolName] = React.useState('')
  // console.log('-----schoolName', schoolName)

  const { data: studentRow, count ,refetch} = useGlobal({
    userUrl: `${urls.TRANSPORT_STUDENT_GET}?school_id=${customRole == 'Admin' ? userSchoolId : schoolName}&page=${page}&limit=${rowsPerPage}&grade_id=${selectedGrade}&section_id=${selectedClass}&month=${selectedMonth}&fee_method=${school_fee_method}&keyword=${search}`,
  })

  const [feeStatus, setFeeStatus] = useState('')
  const [gradeValue, setGradeVal] = useState('')
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=${page}&limit=${highestInt}`,
  })
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name

  // const { data: searchstudent, count: searchcount } = useGlobal({
  //   userUrl: `${urls.STUDENT_SEARCH}${search}&grade_id=${selectedGrade}&fee_status=${feeStatus}&school_id=${customRole == 'Admin' ? userSchoolId : schoolName}&page=${page}&limit=${rowsPerPage}`,
  // })

  const { data: grades } = useGlobal({
    userUrl: `${urls.CLASS_GRADE}${customRole == 'Admin' ? userSchoolId : schoolName}&page=1&limit=10000`,
  })

  // console.log('---grades', grades)
  // const [update, setUpdate] = useState(false)
  // const [detail, setDetail] = useState(false)

  const rowData =  studentRow

  const handleOpen = () => {
    dispatch(setOpenTransportModal(true))
  }

  const handleExport = () => {
    // Get the current data from the table
    const currentData = rowData || []

    if (currentData && currentData.length > 0) {
      // Generate filename with current filters
      let filename = 'Student_List'

      if (schoolName) {
        const school = schoolList?.find((s) => s.school_id === schoolName)
        if (school) {
          filename += `_${school.school_name.replace(/\s+/g, '_')}`
        }
      } else if (customRole === 'Admin' && userSchoolName) {
        filename += `_${userSchoolName.replace(/\s+/g, '_')}`
      }

      if (selectedGrade) {
        const grade = grades?.find((g) => g.grade_id === selectedGrade)
        filename += `_G${grade?.grade || selectedGrade}`
      }

      if (selectedClass) {
        filename += `_C${selectedClass}`
      }

      // Add current date
      const date = new Date().toISOString().split('T')[0]
      filename += `_${date}`

      // Get the data array (handle different possible structures)
      const exportData = Array.isArray(currentData) ? currentData : currentData?.data || []

      if (exportData.length > 0) {
        downloadCSV(exportData, filename)
        // toast.success(`${exportData.length} student records exported`);
      } else {
        toast.error('No data to export')
      }
    } else {
      toast.error('No data to export')
    }
  }

  const no_data_msg =
    customRole == 'Admin'
      ? 'Add Student to start over'
      : schoolName
        ? 'Select school to see Students'
        : 'Select school to see Students'
  const pagecount = search ? searchcount : count
  const handleGradeChange = (event) => {
    const value = event.target.value
    setSelectedGrade(value)
    console.log('Selected grade:', value)
    // You can pass this value to parent or apply filter here
  }

  const handleClassChange = (event) => {
    const value = event.target.value
    setSelectedClass(value)
    console.log('Selected class:', value)
    // You can pass this value to parent or apply filter here
  }
  const handleMonthChange = (event) => {
    const value = event.target.value
    setSelectedMonth(value)
    // console.log('Selected month:', value)
    // You can pass this value to parent or apply filter here
  }

  return (
    <div>
      <Toolbar />
      <DashboardHead title={'Student List'} subtitle={'Class / Students'} />
      {/* <div
        style={{
          marginTop: '24px',
        }}
        className={classes.analyticsContainer}
      >
        {analyticsData.map((card, index) => (
          <DashboardCard key={index} title={card.title} content={card.content} />
        ))}
      </div> */}
      <div
        style={{
          marginTop: '24px',
        }}
        className="school-toolbar"
      >
        <div style={{ width: '40%' }}>
          {customRole != 'Admin' ? (
            <SelectField
              placeholder={'Select School'}
              options={(schoolList || [])?.map((prod) => ({
                value: prod.school_id,
                label: prod.school_name,
              }))}
              name="schoolName"
              value={schoolName}
              onChange={(selectedOption) => setSchoolName(selectedOption)}
              setPage={setPage}
            />
          ) : (
            <InfoField value={userSchoolName} />
          )}
        </div>
      </div>
      <ToolbarComponent
        handleOpen={handleOpen}
        width={'fit-content'}
        transport={true}
        search={search}
        setSearchItem={setSearch}
      >
        {/* <FilterStudent
          feeStatus={feeStatus}
          setFeeStatus={setFeeStatus}
          gradeValue={gradeValue}
          setGradeVal={setGradeVal}
          school_id={
            customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName
          }
        /> */}
        <NewSelectedField
          student={true}
          selectedGrade={selectedGrade}
          selectedMonth={selectedMonth}
          selectedClass={selectedClass}
          school_id={
            customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName
          }
          grades={grades}
          handleClassChange={handleClassChange}
          handleMonthChange={handleMonthChange}
          setSelectedClass={setSelectedClass}
          setSelectedGrade={setSelectedGrade}
          setSelectedMonth={setSelectedMonth}
        />

        {/* <ExportFile icon={FilterIcon} filename={'student'} jsonData={studentRow || []} /> */}
        <FilterSection icon={ImportIcon} onClick={handleExport} title={'Export'} />
        {/* <FilterSection
          icon={ExportIcon}
          onClick={() => dispatch(setOpenImport(true))}
          title={'Import'}
        /> */}
      </ToolbarComponent>
      {search && !searchstudent ? (
        <p>No student Found!</p>
      ) : (
        <DataTable
          headCells={studentTransportHeadCells}
          rowData={rowData}
          studentList
          pages
          pageFee={page}
          noDataMsg={no_data_msg}
          setPageFee={setPage}
          school={false}
          search={search}
          // setUpdate={setUpdate}
          pageCount={pagecount}
          // count={count}
          // handleDetailOpen={() => setDetail(true)}
        />
      )}
      {modalOpen && (
        <AddNewStudentModal
          grades={grades}
          role={customRole}
          schoolList={schoolList}
          userSchoolId={userSchoolId}
          refetch={refetch}
        />
      )}
      {/* {exportOpen && (
        <ExportTransportReport
          role={customRole}
          schoolList={schoolList}
          userSchoolId={userSchoolId}
        />
      )} */}
      {collectFeeOpen && <CollectFeesModal userSchoolId={userSchoolId} refetch={refetch} />}
    </div>
  )
}

export default StudentList
